import { useTranslation } from 'react-i18next';
import { UseFormRegister } from 'react-hook-form';
import type { InitCompanyDto } from '@monorepo/shared';
import { FormInput } from '../ui/FormInput';
import { FormCheckbox } from '../ui/FormCheckbox';
import { VALIDATION_PATTERNS } from '../../constants/validation';

interface ContactInfoErrors {
  phone?: { message?: string };
  contactFirstName?: { message?: string };
  contactLastName?: { message?: string };
  contactEmail?: { message?: string };
}

interface ContactInfoFormProps {
  register: UseFormRegister<InitCompanyDto>;
  errors: ContactInfoErrors;
  isMainContact: boolean;
}

export const ContactInfoForm = ({ register, errors, isMainContact }: ContactInfoFormProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-text border-b pb-2">
        {t('company.section.contact_info')}
      </h2>

      <FormCheckbox label={t('company.is_main_contact.label')} {...register('isMainContact')} />

      {isMainContact ? (
        <FormInput
          label={t('company.phone.label')}
          type="tel"
          placeholder={t('company.phone.placeholder')}
          error={errors.phone?.message}
          required
          {...register('phone', {
            required: t('company.phone.error.required'),
            pattern: {
              value: VALIDATION_PATTERNS.PHONE,
              message: t('company.phone.error.invalid'),
            },
          })}
        />
      ) : (
        <div className="ml-6 space-y-4 p-4 bg-gray-50 rounded-lg">
          <p className="text-sm text-secondary mb-4">{t('company.contact.description')}</p>

          <FormInput
            label={t('company.contact.first_name.label')}
            type="text"
            placeholder={t('company.contact.first_name.placeholder')}
            error={errors.contactFirstName?.message}
            required
            {...register('contactFirstName', {
              required: !isMainContact ? t('company.contact.first_name.error.required') : false,
            })}
          />

          <FormInput
            label={t('company.contact.last_name.label')}
            type="text"
            placeholder={t('company.contact.last_name.placeholder')}
            error={errors.contactLastName?.message}
            required
            {...register('contactLastName', {
              required: !isMainContact ? t('company.contact.last_name.error.required') : false,
            })}
          />

          <FormInput
            label={t('company.contact.email.label')}
            type="email"
            placeholder={t('company.contact.email.placeholder')}
            error={errors.contactEmail?.message}
            required
            {...register('contactEmail', {
              required: !isMainContact ? t('company.contact.email.error.required') : false,
              pattern: {
                value: VALIDATION_PATTERNS.EMAIL,
                message: t('company.contact.email.error.invalid'),
              },
            })}
          />

          <FormInput
            label={t('company.phone.label')}
            type="tel"
            placeholder={t('company.phone.placeholder')}
            error={errors.phone?.message}
            required
            {...register('phone', {
              required: t('company.phone.error.required'),
              pattern: {
                value: VALIDATION_PATTERNS.PHONE,
                message: t('company.phone.error.invalid'),
              },
            })}
          />
        </div>
      )}
    </div>
  );
};
